import EventBus from '../services/EventBus';

export default (all, inject) => {
  const eventBus = new EventBus();
  inject('eventBus', eventBus);
};
